import { joinNames } from '../../utils/common/formatText';
import { Metadata } from '../types';

import {
  RawShortStudent, RawStudent, ShortStudent, Student,
} from './types';

export const toStudent = ({
  data, metadata,
}: {
  data: RawStudent, metadata: Metadata
}): {data: Student, metadata: Metadata} => ({
  data: {
    ...data,
    id: data.studentId,
    name: joinNames([data.firstName, data.lastName]),
  },
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    name: {
      hide: true,
      label: 'Name',
      type: 'text',
      editable: false,
    },
  },
});

export const toShortStudents = ({
  data, metadata,
}: {
  data: RawShortStudent[], metadata: Metadata
}): {data: ShortStudent[], metadata: Metadata} => ({
  data: data.map((student) => ({
    ...student,
    id: student.studentId,
    name: joinNames([student.firstName, student.lastName]),
  })),
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    name: {
      hide: true,
      label: 'Name',
      type: 'text',
      editable: false,
    },
  },
});
